import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

export type SurfaceDensity = 'default' | 'comfortable' | 'tight';

type BorderColor = 'gray-200' | 'gray-300';
type Radius = 'rounded-sm' | 'rounded' | 'rounded-lg';
type Elevation = 'shadow' | 'shadow-none';
type Padding = 'p-2' | 'p-8' | 'p-10';

type SurfacePreset = {
  borderColor: BorderColor;
  radius: Radius;
  elevation: Elevation;
  padding: Padding;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSurface',
  props: {
    density: { default: 'default' }
  },
  setup(__props: any) {

const DENSITY_PRESETS: Record<SurfaceDensity, SurfacePreset> = {
  default: {
    borderColor: 'gray-300',
    radius: 'rounded-lg',
    elevation: 'shadow',
    padding: 'p-10'
  },
  comfortable: {
    borderColor: 'gray-300',
    radius: 'rounded-lg',
    elevation: 'shadow',
    padding: 'p-8'
  },
  tight: {
    borderColor: 'gray-200',
    radius: 'rounded-lg',
    elevation: 'shadow-none',
    padding: 'p-2'
  }
};

const props = __props;

const resolvedClasses = computed(() => {
  const preset = DENSITY_PRESETS[props.density];

  return [
    'bg-white',
    'border',
    preset.borderColor === 'gray-200'
      ? 'border-gray-200'
      : 'border-gray-300',
    preset.radius,
    preset.elevation,
    preset.padding
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(resolvedClasses.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})